import { BackgroundColors } from '@/@types/types';
import { UserUiDto } from '@/api';

export default {
  path: 'ai',
  name: 'settings.ai',
  meta: {
    requiresAuth: true,
    roles: [UserUiDto.role.ADMIN],
    breadCrumb: 'app.navigation-drawer.ai',
    background: BackgroundColors.SECONDARY,
  },
  component: () => import('@/views/FrontendNextRouteView.vue'),
};
